import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function InfoBox({ children, className, as, ...rest }) {
    const Component = as ?? "div";
    return (_jsx(Component, { className: classNames("cvr-info-box", className), ...rest, children: children }));
}
